export * from './YfmTabsSpecs/const';
export {tabType, tabPanelType, tabsListType, tabsType} from './YfmTabsSpecs';

export const YFM_TAB_CLASSNAME = 'yfm-tab';
export const DIPLODOC_ID_ATTR = 'data-diplodoc-id';

export const tabActiveClassname = `${YFM_TAB_CLASSNAME} active`;
export const tabInactiveClassname = YFM_TAB_CLASSNAME;
export const tabPanelActiveClassname = 'yfm-tab-panel active';
export const tabPanelInactiveClassname = 'yfm-tab-panel';
